var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpper = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3.205 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-12a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M14.86 10.905v3.008a.3.3 0 0 1-.117.24.44.44 0 0 1-.288.097.44.44 0 0 1-.289-.097.3.3 0 0 1-.116-.24v-3.008l-1.152.96a.4.4 0 0 1-.284.097.47.47 0 0 1-.283-.097.32.32 0 0 1-.126-.24.29.29 0 0 1 .116-.24l1.85-1.542a.4.4 0 0 1 .132-.072.53.53 0 0 1 .303 0 .4.4 0 0 1 .132.072l1.85 1.542a.29.29 0 0 1 .116.24.32.32 0 0 1-.126.24.47.47 0 0 1-.283.097.4.4 0 0 1-.283-.097l-1.153-.96Zm-3.552 3.345h-.624a.3.3 0 0 1-.174-.051.3.3 0 0 1-.096-.132l-.324-.885H8.293l-.324.885a.3.3 0 0 1-.096.126.26.26 0 0 1-.171.057h-.627l1.704-4.338h.825zM8.5 12.612h1.383l-.528-1.443-.081-.225a7 7 0 0 1-.084-.285 7 7 0 0 1-.162.516z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upper.fe001b13.svg";